import { convertFromRaw, EditorState } from 'draft-js';
import * as React from 'react';
import { Editor } from 'react-draft-wysiwyg';

// use pages/_app.scss

interface Props {
  value: string;
}

interface State {
  // tslint:disable-next-line: no-any
  editorState?: any;
}

class RichViewer extends React.Component<Props, State> {
  public state: State = {
    editorState: undefined,
  };

  public componentDidMount() {
    const { value } = this.props;
    let editorState;

    try {
      editorState = EditorState.createWithContent(
        convertFromRaw(JSON.parse(value)),
      );
    } catch (e) {
      editorState = EditorState.createEmpty();
    }

    this.setState({ editorState });
  }

  public render() {
    const { editorState } = this.state;

    return (
      <Editor
        readOnly={true}
        toolbarHidden={true}
        editorKey="editor"
        editorState={editorState}
      />
    );
  }
}

export default RichViewer;
